import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduce, first, find, delay } from 'lodash';
import moment from 'moment';
import { Collapse } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import styles from '../../../../components/search-form/styles.css';
import masterField from '../../../../components/search-form/master-field';
import PredefinedRangeSelector from '../../../../components/search-form/predefined-range-selector';

const format = 'YYYY-MM-DD';
const displayFormat = 'MMM DD, YYYY';

class PeriodField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      selectedRanges: null,
      currentLabel: 'Custom',
      openModal: false,
    };
    this.selectRange = this.selectRange.bind(this);
  }

  componentWillMount() {
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }

  checkProps(props) {
    const { startDate, endDate } = this.state;
    const { periods } = props;
    const [newStartDate, newEndDate] = props.values;
    if (newStartDate !== startDate || newEndDate !== endDate) {
      const selectedRanges = reduce(periods, (items, predefinedRange) => {
        const ranges = reduce(predefinedRange.ranges, (rangeItems, range) => {
          if (range.start === newStartDate && range.end === newEndDate) {
            rangeItems.push(range);
          }
          return rangeItems;
        }, []);
        if (ranges.length) {
          items.push({ ...predefinedRange, ranges });
        }
        return items;
      }, []);
      let currentLabel = null;
      if (selectedRanges && selectedRanges.length) {
        const selectedRange = first(selectedRanges);
        if (selectedRange) {
          const firstRange = first(selectedRange.ranges);
          if (firstRange) {
            if (firstRange.displayLabel) {
              currentLabel = firstRange.displayLabel;
            } else {
              currentLabel = selectedRange.label;
            }
          }
        }
      }
      this.setState({
        startDate: newStartDate, endDate: newEndDate, selectedRanges, currentLabel,
      });
    }
  }

  selectRange(range) {
    this.setState({ openModal: false });
    delay(() => {
      this.props.onChange([range.start, range.end]);
    }, 100);
  }

  renderModal() {
    const { selectedRanges } = this.state;
    const { periods } = this.props;
   
    return (
      <div className={`panel panel-default ${styles.dateRangePanel}`}>
        <div className="panel-heading">
          <h3 className="panel-title clearfix">
            Select a period
          </h3>
        </div>
        <div className="panel-body">
          <PredefinedRangeSelector
            predefinedRanges={periods}
            selectedRanges={selectedRanges}
            selectRange={this.selectRange}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      currentLabel, openModal, startDate, endDate,
    } = this.state;
    const { disabled } = this.props;
    let suffix = null;
    if (startDate && endDate) {
      suffix = `From ${moment(startDate, format).format(displayFormat)} to ${moment(endDate, format).format(displayFormat)}`;
    }
    const label = currentLabel === null ? suffix : currentLabel;
    return (
      <div>
        <div>
          <a
            className="clickable"
            disabled={disabled}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!disabled) {
                this.setState({ openModal: !openModal });
              }
            }}
          >
            {label} {suffix !== null && currentLabel !== null && <small>{suffix}</small>}
          </a>
        </div>
        {openModal && <p />}
        <Collapse in={openModal}>
          {this.renderModal()}
        </Collapse>
      </div>
    );
  }
}

PeriodField.propTypes = {
  disabled: PropTypes.bool,
  periods: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,

};
PeriodField.defaultProps = {
  onChange: () => {},
};
export default masterField(PeriodField);
